import React from 'react';
import { AppBar, Box, IconButton, Toolbar, Typography, useTheme, alpha, Tooltip, Tabs, Tab } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import LogoutIcon from '@mui/icons-material/Logout';
import { useThemeMode } from '../theme';
import { useAuth } from '../hooks/useAuth';
import { AppSwitcher } from 'ui-cross-app';

export const TravelAppBar: React.FC = () => {
  const theme = useTheme();
  const { mode, toggle } = useThemeMode();
  const { logout, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const current = location.pathname.startsWith('/admin/vouchers')
    ? '/admin/vouchers'
    : location.pathname.startsWith('/admin/settings')
      ? '/admin/settings'
      : '/';

  return (
    <AppBar position="sticky" elevation={0} color="default" sx={{ borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`, backgroundColor: theme.palette.background.paper }}>
      <Toolbar sx={{ minHeight: 56, px: { xs: 1.5, sm: 2, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mr: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
            Optima Travel
          </Typography>
        </Box>

        <Tabs
          value={current}
          onChange={(_, val) => navigate(val)}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 48,
            '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, minHeight: 48 },
          }}
        >
          <Tab label="Travels" value="/" component={Link} to="/" />
          <Tab label="Vouchers" value="/admin/vouchers" component={Link} to="/admin/vouchers" />
          <Tab label="Admin settings" value="/admin/settings" component={Link} to="/admin/settings" />
        </Tabs>

        <Box sx={{ flex: 1 }} />

        {user && (
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 1.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {user.name || user.username || '—'}
            </Typography>
          </Box>
        )}

        <AppSwitcher currentAppId="travel" />

        <Tooltip title={mode === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}>
          <IconButton color="primary" onClick={toggle} size="small" aria-label="Toggle color theme" sx={{ mr: 0.5 }}>
            {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </Tooltip>

        <Tooltip title="Logout">
          <IconButton color="primary" onClick={logout} size="small" aria-label="Logout">
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};
